export default function ContinueVerificationPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-lg">
        <h2 className="text-center text-3xl font-extrabold text-gray-900">
          Continue Verification
        </h2>
        <p className="text-center text-gray-600">Continue verification page - To be ported</p>
      </div>
    </div>
  );
}
